{
    "CallsansweredwithinLabel": "As chamadas devem ser atendidas em:",
    "CallsansweredwithinPlaceholder": "10",
    "CallsansweredwithinUnit": "s",
    "ServiceLvlSettings_SectionHeader": "Configurações de nível de serviço",
    "ServiceLvlSettings_SectionPara": "Você pode ajustar as configurações a seguir para controlar especificamente como o relatório atual calcula a estatística \"% nível de serviço\" quando ela é compatível com o estilo de relatório escolhido e também é selecionada para exibição.",
    "ServiceLvlSettings_IgnorequickabndcallswithinLabel": "Ignorar chamadas abandonadas rápidas em:",
    "ServiceLvlSettings_IgnorequickabndcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnorequickabndcallswithinEnabledHiddenlabel": "A configuração \"Ignorar chamadas rápidas abandonadas dentro\" está habilitada?",
    "ServiceLvlSettings_IgnorequickabndcallswithinUnit": "s",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinLabel": "Ignorar chamadas transbordadas em:",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinEnabledHiddenlabel": "A configuração \"Ignorar chamadas transbordadas dentro\" está habilitada?",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinUnit": "s",
    "NAME": "ServiceLvlSettings"
}